/**
 * A counter that can also be a filter.
 *
 * The fleet's six tiles were numbers to read. As filter chips they are numbers
 * to press — "14 faults" becomes the fourteen — which is the faults-first
 * screen the owner asked for without a second control to learn.
 */

import type React from 'react';

import type { PillState } from './Pill.tsx';

export function Stat({
  n,
  label,
  state = 'neutral',
  active = false,
  onClick,
}: {
  n: number;
  label: string;
  state?: PillState;
  active?: boolean;
  onClick?: () => void;
}): React.JSX.Element {
  const classes = ['stat', state];
  if (n === 0) classes.push('zero');
  if (active) classes.push('active');
  const body = (
    <>
      <span className="stat-n">{n}</span>
      <span className="stat-k">{label}</span>
    </>
  );
  if (onClick === undefined) return <div className={classes.join(' ')}>{body}</div>;
  return (
    <button type="button" className={classes.join(' ')} onClick={onClick} aria-pressed={active}>
      {body}
    </button>
  );
}

export function StatRow({ children }: { children: React.ReactNode }): React.JSX.Element {
  return <div className="stat-row">{children}</div>;
}
